// @flow
import * as React from 'react';

import Box from 'sail/Box';
import Group from 'sail/Group';
import {BodyAlt} from 'sail/Text';
import Select, {SelectOption} from 'sail/Select';
import {capitalize} from 'lodash';

type SetNodeStateProps = {|
  value: string,
  onChange: (string) => void,
|};
// Renders a dropdown for overview diagram nodes to select an icon
export const SetNodeState = ({value, onChange}: SetNodeStateProps) => {
  const NODE_STATES = ['warning', 'error', 'success'];

  return (
    <Group spacing={4}>
      <label htmlFor="nodeState">
        <BodyAlt>State</BodyAlt>
      </label>
      <Box>
        <Select id="nodeState" onChange={onChange} value={value}>
          <SelectOption key="none" label={'No state'} value={''} />
          {NODE_STATES.map((n) => (
            <SelectOption key={n} label={capitalize(n)} value={n} />
          ))}
        </Select>
      </Box>
    </Group>
  );
};
